import React from "react";

export default function Sponsor() {
  return (
    <section className="py-10 px-5 sm:px-10 lg:px-20">
      <h2 className="text-3xl md:text-4xl text-gray-800 text-center mb-6">
        Why Sponsor Immunocon-2025?
      </h2>
      <ul className="space-y-4 text-gray-700">
        <li>
          <strong className=">Strategic Visibility:</strong> Showcase your brand to a
          distinguished audience of national and international immunology
          professionals.
        </li>
        <li>
          <strong className=">Direct Engagement:</strong> Utilize Tech Talks and exhibition
          spaces to interact with participants.
        </li>
        <li>
          <strong className=">Industry-Academia Collaboration:</strong> Strengthen
          partnerships with academic and research institutions.
        </li>
        <li>
          <strong className=">Enhanced Brand Recognition:</strong> Benefit from extensive
          promotional campaigns across digital platforms and event
          publications.
        </li>
      </ul>

      <div className="mt-8">
        <p className="text-gray-700">
          To download the Proposal for sponsorship:{" "}
          <a
            href="/Immunocon Sponsorship proposal.pdf"
            download
            target="_blank"
            rel="noopener noreferrer"
            className="text-indigo-500 underline hover:text-indigo-800"
          >
            click here
          </a>
        </p>
        <p className="text-gray-700">
          To download the  Exhibitors brochure:{" "}
          <a
            href="/Immunocon Exhibitors brochure.pdf"
            download
            target="_blank"
            rel="noopener noreferrer"
            className="text-indigo-500 underline hover:text-indigo-800"
          >
            click here
          </a>
        </p>
      </div>

      <div className="mt-9 bg-white rounded-lg txt">
        <h3 className="text-xl font-semibold mb-4">Contact Information</h3>
        <p className="text-gray-700">
          For sponsorship inquiries and further details, please contact:
        </p>
        <p className="text-gray-700 mt-4">
          <strong>Dr. Ambak Kumar Rai</strong>
          <br />
          Associate Professor, Department of Biotechnology
          <br />
          Motilal Nehru National Institute of Technology Allahabad
          <br />
          Prayagraj-211004 (UP), India
          <br />
          Phone:{" "}
          <a
            href="tel:+918543920303"
            className="text-indigo-500 underline hover:text-indigo-800"
          >
            +91-8543920303
          </a>
          <br />
          Email:{" "}
          <a
            href="mailto:immunocon2025@mnnit.ac.in"
            className="text-indigo-500 underline hover:text-indigo-800"
          >
            immunocon2025@mnnit.ac.in
          </a>
          <br />
          Website:{" "}
          <a
            href="https://www.immunocon2025.com"
            target="_blank"
            rel="noopener noreferrer"
            className="text-indigo-500 underline hover:text-indigo-800"
          >
            www.immunocon2025.com
          </a>
        </p>
      </div>

      <p className="mt-8 text-gray-700 text-center">
        We look forward to your valued partnership in making Immunocon-2025 a
        transformative and impactful event, advancing the intersection of
        immunology and technology for a healthier future.
      </p>
    </section>
  );
}